module.exports = __webpack_public_path__ + "img/cutting-edge-jp-3.e77b0bf.jpg";